import { memo } from "react";

import { isPresent } from "neetocist";
import { Down, Close } from "neetoicons";
import { Typography } from "neetoui";
import { isNil } from "ramda";
import { useTranslation } from "react-i18next";

import { ICON_SIZE } from "./constants.js";

const Target = ({
  color,
  value,
  label,
  dataTestid,
  isClearable,
  onClear,
  placeholder,
}) => {
  const { t } = useTranslation();
  const targetClassName = `neeto-ui-rounded-sm inline-flex items-center gap-2 cursor-pointer py-0.5 px-2 status-dropdown-target--${
    color || "waiting"
  }`;
  const isOptionSelected = !isNil(value);

  const handleClearClick = event => {
    onClear();
    event.stopPropagation();
  };

  const handleClearKeyDown = event => {
    if (!(event.key === "Enter" || event.key === " ")) return;
    event.preventDefault();
    handleClearClick(event);
  };

  return (
    <button
      aria-haspopup="listbox"
      className={targetClassName}
      data-testid={isPresent(dataTestid) ? dataTestid : "status-dropdown"}
      type="button"
      aria-label={
        isOptionSelected
          ? `Selected: ${label}`
          : placeholder || t("neetoMolecules.statusDropdown.placeholder")
      }
    >
      {isOptionSelected ? (
        <Typography className="inline" style="body2">
          {label}
        </Typography>
      ) : (
        <Typography className="neeto-ui-text-gray-600 inline" style="body2">
          {placeholder || t("neetoMolecules.statusDropdown.placeholder")}
        </Typography>
      )}
      <span className="inline-flex items-center gap-1">
        {isClearable && isOptionSelected && (
          <span
            aria-label={t("neetoMolecules.statusDropdown.clear")}
            className="cursor-pointer"
            data-testid="status-dropdown-clear-button"
            role="button"
            tabIndex={0}
            onClick={handleClearClick}
            onKeyDown={handleClearKeyDown}
          >
            <Close size={ICON_SIZE} />
          </span>
        )}
        <Down aria-hidden="true" size={ICON_SIZE} />
      </span>
    </button>
  );
};

export default memo(Target);
